import { Card, CardContent, Typography } from "@mui/material";
import ScheduleIcon from "@mui/icons-material/Schedule";
import { CardHeaderCore } from "src/Pages/components/CardCore/Components/CardHeaderCore";
import { PreviewIcon } from "src/Pages/components/Icons/Icons";

export const PageReportAniversariantes = () => {
  return (
    <>
      <CardHeaderCore
        icon={<PreviewIcon color="primary" sx={{ fontSize: "20px" }} />}
        sxStyle={{ margin: "1px 0 16px 0", padding: "12px" }}
        subTitle="Relatório de aniversariantes por cliente"
        title="Aniversariantes — Clientes"
      />

      <Card
        elevation={0}
        sx={{
          maxWidth: 420,
          mx: "auto",
          mt: 4,
          borderRadius: 2,
          border: "1px solid",
          borderColor: "divider",
          overflow: "hidden",
          textAlign: "center",
          bgcolor: "background.paper",
        }}
      >
        <CardContent sx={{ py: 4, px: 3 }}>
          <ScheduleIcon
            sx={{
              fontSize: 56,
              color: "primary.main",
              opacity: 0.9,
              mb: 2,
            }}
          />
          <Typography variant="h6" fontWeight={600} color="text.primary" gutterBottom>
            Em breve
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 320, mx: "auto" }}>
            O relatório de aniversariantes por cliente está em desenvolvimento e estará disponível em breve.
          </Typography>
        </CardContent>
      </Card>
    </>
  );
};
